import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

setTimeout(function () {
    let rootElement = document.getElementById('root');

    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <App/>
            </React.StrictMode>
        );
    }
}, 1000);
